<template>
  <div
    id="select-ingredient-modal-5"
    tabindex="-1"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 hidden w-full px-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full"
  >
    <div class="relative w-full h-full max-w-3xl md:h-auto">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow ">
        <button
          type="button"
          class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center  "
          @click="onClose"
        >
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <!-- Modal header -->
        <div class="px-6 py-4 border-b rounded-t  bg-gray-600">
          <h3 class="text-base font-semibold text-gray-100 lg:text-xl ">{{ labels["TITLE_INGREDIENTS"][lg] }} - {{ input?.section.name }}</h3>
        </div>
        <!-- Modal body -->
        <div class="p-6 w-full bg-white-100">
          <p class="text-sm font-normal text-gray-500 ">
            {{ labels["TITLE_SELECT_PRODUCT_TYPE_COMMENT_CUSTOMER"][lg] }}
          </p>

          <div class="text-sm font-medium mb-3 text-center text-gray-500 border-b border-gray-200  ">
            <ul class="flex flex-wrap -mb-px">
              <li class="me-2">
                <div
                  @click="OnSelectRawMaterial"
                  class="inline-block cursor-pointer p-4 border-b-2 rounded-t-lg"
                  :class="{
                    'text-blue-600   border-blue-600 rounded-t-lg active  ': selectedTab == 0,
                    'border-transparent hover:text-gray-600 hover:border-gray-300 ': selectedTab != 0,
                  }"
                >
                  Matières Premières
                </div>
              </li>
              <li class="me-2">
                <div
                  @click="OnSelectPackaging"
                  class="inline-block p-4 cursor-pointer border-b-2"
                  :class="{
                    'text-blue-600   border-blue-600 rounded-t-lg active  ': selectedTab == 1,
                    'border-transparent hover:text-gray-600 hover:border-gray-300 ': selectedTab != 1,
                  }"
                  aria-current="page"
                >
                  Emballages Primaires
                </div>
              </li>
            </ul>
          </div>

          <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only ">Recherche</label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
              </svg>
            </div>
            <input
              id="default-search"
              v-model="searchText"
              type="search"
              class="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500      "
              placeholder="Search Mockups, Logos..."
              required
              @input="onSearchInput"
              @change="onSearchChange"
            />
          </div>

          <div class="flex flex-row pt-4">
            <ul class="border-2 border-gray-200 space-y-3 overflow-y-auto h-96 w-full" :class="{ 'bg-blue-100': loading0, 'bg-gray-100': loading0 }">
              <li class="hidden w-full bg-gray-600 text-white">0</li>
              <li v-for="item in filteredTypes0" :key="item._id" class="cursor-pointer">
                <div
                  class="border border-gray-200 mx-1 flex items-center px-1 py-3 text-base font-bold rounded-lg group hover:shadow   "
                  :class="{ 'text-white bg-gray-600 hover:bg-gray-700': selected0 == item._id, 'text-gray-900 bg-gray-50 hover:bg-gray-100': selected0 != item._id }"
                  @click="onProductSelect0(item)"
                  @dblclick="onProductSelectQuit(item)"
                >
                  <i class="hidden fa-solid fa-xl fa-solid fa-chevron-right" />
                  <span class="flex-1 text-left px-1 whitespace-nowrap text-sm truncate">{{ item.name }}</span>
                  <i v-if="selected0 == item._id && item.hasChildren" class="fa-solid fa-lg fa-chevron-right mr-1" />
                  <span class="hidden inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded  ">Popular</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="flex items-center justify-between px-4 py-3 mt-3 bg-gray-100 border-t rounded-b">
          <div class="text-gray-500 italic text-xs">*344*</div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose()"
            >
              Annuler
            </button>
            <button
              type="button"
              :disabled="!isActive()"
              class="inline-flex items-center focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
              :class="{ 'text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 ': isActive(), 'text-white bg-gray-300  ': !isActive() }"
              @click="onValidate"
            >
              VALIDER
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
  *"Je veux une classification hiérarchique en 5 niveaux maximum pour une liste d’ingrédients utilisée dans un logiciel SaaS. La racine est "Ingrédient" (inutile de l’indiquer dans la classification).
  
  Chaque ingrédient doit être classé en catégories logiques et hiérarchiques en fonction de son origine et son usage.
  Ajoute un niveau supplémentaire lorsqu'il est pertinent (exemple : pour les viandes, précise l'animal).
  Classe les sels, épices, sucres, liquides, boyaux, et additifs selon une logique claire.
  Maintiens une structure simple, lisible et organisée, avec des sous-catégories pertinentes.
  Voici la liste des ingrédients à classer :
  
  Jambon de Porc
  Pied de Porc
  Viande de Sanglier
  Joue de Bœuf
  Sel nitrité
  Poivre noir moulu
  Muscade moulue
  Carvi en poudre
  Ail en poudre
  Coriandre moulue
  Vin rouge
  Boyau naturel
  Boyau artificiel Nalo Top Brun 60
  Glace
  Sel de mer fin
  Sucre : Dextrose
  Liant Cutter Mix PH 7.3
  Génère la classification hiérarchique détaillée avec 5 niveaux maximum, en respectant une structure logique et exhaustive."*
  */

import service from "@/services/FullService.vue";
import labels from "@/assets/lg/product-types.json";

import { mapGetters } from "vuex";
export default {
  name: "SelectIngredientModal3",
  props: {
    refresh: String,
    category: String,
    input: Object,
  },
  data() {
    return {
      lg: "FR",
      labels: labels,
      searchText: "",
      records: [],
      src: "",
      isValid: false,
      filteredTypes0: [],
      selected0: null,
      selectedTab: 0,
      allTypes0: [],
      allTypes1: [],

      loading0: false,

      selected: null,
    };
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    refresh: async function () {
      let data = await this.loadItems("684d3b7d98135e80d1438e09", null);
      this.allTypes0 = data.records;
      this.filteredTypes0 = this.allTypes0;

      let data2 = await this.loadItems("684ed410b70f354cc31cbb41", null);
      this.allTypes1 = data2.records;
      this.filteredTypes1 = this.allTypes1;

      this.searchText = "";
      this.selected = null;
      this.selected0 = null;
    },
  },
  async mounted() {
    if (this.user == undefined) {
      //this.$router.push("/login");
      window.location = "/login";
      return;
    }

    let data = await this.loadItems("684d3b7d98135e80d1438e09", null);

    this.allTypes0 = data.records;

    let data2 = await this.loadItems("684ed410b70f354cc31cbb41", null);
    this.allTypes1 = data2.records;

    this.filteredTypes0 = this.allTypes0;
  },
  methods: {
    OnSelectRawMaterial() {
      this.filteredTypes0 = this.allTypes0;

      this.searchText = "";
      this.selected = null;
      this.selected0 = null;
      this.selectedTab = 0;
    },
    OnSelectPackaging() {
      this.filteredTypes0 = this.allTypes1;

      this.searchText = "";
      this.selected = null;
      this.selected0 = null;
      this.selectedTab = 1;
    },
    isActive() {
      if (this.selected == undefined) return false;
      return !this.selected.hasChildren;
    },

    onValidate() {
      this.$emit("select", this.selected);
    },

    onSearchInput() {
      let searchText = this.searchText;
      this.filteredTypes0 = this.allTypes0?.filter(function (el) {
        return el.name.toUpperCase().includes(searchText.toUpperCase());
      });
    },

    onSearchChange() {},

    async loadItems(source_id /*, parent_id */) {
      let data = [];
      let limit = 1000;
      let offset = 0;
      //let filter = { parent_id: parent_id, category: this.category }
      let filter = {};

      let collection = "data-sources/" + source_id + "/records";
      // let collection = "ingredient-types"
      this.src = collection;
      data = await service.getData(collection, this.user?.token, Object.assign({}, { limit: limit, offset: offset }, filter));

      if (data == null) {
        data = [];
      }
      return data;
    },

    async onProductSelect0(item) {
      this.selected0 = item._id;
      this.selected = { item: item, section: this.input.section };

      //    this.$emit("select", item)
    },

    async onProductSelectQuit(item) {
      this.selected0 = item._id;
      this.selected = { item: item, section: this.input.section };

      this.$emit("select", this.selected);
    },

    onClose() {
      this.$emit("close");
    },
  },
  components: {},
};
</script>
